
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'SalesDepartmentBlock',

    computed: {
        vars() {
            return this.$store.state?.appState?.vars || {};
        },
        config() {
            return this.$store?.state?.appState?.config || {};
        },
        contacts() {
            const { vars } = this;

            const list = [];

            // Офис отдела продаж
            const salesOffice = vars?.['Полный адрес'];
            if (salesOffice) {
                list.push({
                    icon: require('~/assets/img/svg/contacts/pin.svg'),
                    title: 'Офис отдела продаж:',
                    message: salesOffice,
                    href: '',
                });
            }

            // Номер телефона отдела продаж
            let salesDepartmentPhoneNumbers = vars?.['Номер телефона отдела продаж'];
            if (salesDepartmentPhoneNumbers) {
                salesDepartmentPhoneNumbers = salesDepartmentPhoneNumbers.split(',');

                if (salesDepartmentPhoneNumbers.length > 0) {
                    salesDepartmentPhoneNumbers.forEach((phoneNumber) => {
                        list.push({
                            icon: require('~/assets/img/svg/contacts/phone.svg'),
                            title: 'Номер телефона отдела продаж:',
                            message: this.$phoneFormat(phoneNumber),
                            href: `tell:${phoneNumber}`,
                        });
                    });
                }
            }

            // Режим работы отдела продаж
            const workingHoursSalesDepartment = vars?.['Режим работы отдела продаж'];
            if (workingHoursSalesDepartment) {
                list.push({
                    icon: require('~/assets/img/svg/contacts/clock.svg'),
                    title: 'Режим работы отдела продаж:',
                    message: workingHoursSalesDepartment,
                    href: '',
                });
            }

            // E-mail отдела продаж
            const salesEmail = vars?.['E-mail отдела продаж'];
            if (salesEmail) {
                list.push({
                    icon: require('~/assets/img/svg/contacts/email.svg'),
                    title: 'E-mail отдела продаж:',
                    message: salesEmail,
                    href: `mailto:${salesEmail}`,
                });
            }

            return list;
        },
        socials() {
            const { config } = this;
            const { vars } = this;

            const list = [];
            if (config.vkontakte) {
                list.push({
                    url: config.vkontakte,
                    icon: require('~/assets/img/svg/contacts/vk.svg'),
                });
            }
            if (config.telegram) {
                list.push({
                    url: config.telegram,
                    icon: require('~/assets/img/svg/contacts/telegram.svg'),
                });
            }
            if (config.whatsapp) {
                list.push({
                    url: config.whatsapp,
                    icon: require('~/assets/img/svg/contacts/whatsapp.svg'),
                });
            }

            return list;
        },
        yandexMapIframe() {
            return this.vars?.['Карта отдела продаж'];
        },

        isLightTheme() {
            return Boolean(this.cfgs?.theme === 'light');
        },
    },
});
